import { Link } from "react-router-dom"

import { Button } from "@/components/ui/button"

type CandidateVacancyBannerProps = {
  vacancyTitle?: string | null
  vacancyCompany?: string | null
  vacancyUrl?: string | null
}

const CandidateVacancyBanner = ({
  vacancyTitle,
  vacancyCompany,
  vacancyUrl,
}: CandidateVacancyBannerProps) => {
  const title = vacancyTitle?.trim() ?? null
  const company = vacancyCompany?.trim() ?? null
  const hasTitle = Boolean(title)
  const hasCompany = Boolean(company)

  return (
    <div className="rounded-xl bg-primary px-6 py-5 text-white shadow-sm">
      <div className="flex flex-col gap-3 lg:flex-row lg:items-center lg:justify-between">
        <p className="text-base font-medium">
          <span>Sollicitant</span>
          {hasTitle ? (
            <>
              {" voor "}
              <span className="font-semibold">{title}</span>
            </>
          ) : null}
          {hasCompany ? (
            <>
              {" bij "}
              <span className="font-semibold">{company}</span>
            </>
          ) : null}
        </p>
        {vacancyUrl ? (
          <Button
            asChild
            variant="outline"
            size="sm"
            style="pill"
            className="border-white text-white hover:bg-white/10 hover:text-white"
          >
            <Link to={vacancyUrl}>Bekijk Vacature</Link>
          </Button>
        ) : null}
      </div>
    </div>
  )
}

export default CandidateVacancyBanner
